mutation exportLeadToCrm($id: ID!) {
  exportLeadToCrm(id: $id)
}
